"use client";
import React, { CSSProperties, memo } from "react";
import { button } from "../CommonForm/CommonFormInterface";

import CustomImage from "../CustomImage/CustomImage";

const Button = memo(({
  style,
  disabledStyle,
  className,
  field,
  children,
  buttonId,
  fieldKey,
  activeKey,
  handleClick,
  handleOnBlur,
  buttonLabel,
  handleMouesHoverOnImage,
  activeStyles,
  extractedSrc,
  imageAlt,
  imagePriority,
  imageFetchPriority,
  disabled
}: {
  style: CSSProperties;
  disabledStyle: CSSProperties;
  className?: string;
  field: button;
  children:React.ReactNode
  buttonId: string,
  fieldKey: string
  activeKey:any
  handleClick:Function
  handleOnBlur:Function
  buttonLabel:string
  handleMouesHoverOnImage:Function
  extractedSrc:string
  activeStyles:any
  imageAlt:string
  imagePriority:boolean
  imageFetchPriority:"auto" | "high" | "low" | undefined,
  disabled: boolean
}) => {

  return (
    <button
      style={{ "cursor":"pointer",...style, ...((fieldKey === activeKey || buttonId === activeKey) ? field?.activeItemStyle : {}),fontFamily: 'Gotham, system-ui, sans-serif', ...(disabled ? disabledStyle : {}) }}
      className={`${className} ${(fieldKey === activeKey || buttonId === activeKey) ? field?.activeButtonClassName : ""}`}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleClick(e)}
      onBlur={(e: React.FocusEvent<HTMLButtonElement>) => handleOnBlur(e)}
      id={buttonId??""}
      disabled={disabled}
    >
      {field?.children ? (
              children
            ) : (
              <>
                {field?.imageUrl && (
                  <CustomImage
                    field={{...field,actions:[]}}
                    extractedSrc={extractedSrc}
                    activeStyles={activeStyles}
                    imageAlt={imageAlt}
                    imagePriority={imagePriority}
                    imageFetchPriority={imageFetchPriority}
                    handleMouesHoverOnImage={handleMouesHoverOnImage}
                  />
                )}
                {buttonLabel}
              </>
            )}
    </button>
  );
});

export default Button;
